// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"d32939a8","108":"b67bcc1a","243":"ef68934e","396":"703de6c0","608":"b4a7178d","636":"2f6177a1","671":"fbbd35cf","710":"2dc593ed","896":"985d2654"}[chunkId] + ".chunk.js";
};